import React from 'react'
import TextField from '@mui/material/TextField';


interface Props {
    value: number | undefined | null;
    onChange: (name: string, value: number) => void
    name: string
    disabled: boolean | undefined
}
const CustomNumberInputChanger: React.FC<Props> = ({ value, onChange, name, disabled }) => {

    return (
        <div style={{ display: "flex", position: "relative" }}>
            <TextField
                size="small"
                style={{ width: "135px", background: "#ffffff" }}
                value={value ? parseFloat(value.toFixed(2)) : 0}
                name={name}
                disabled={disabled}
                onChange={(e): void => {
                    console.log(e.target.name, e.target.value)
                    onChange(e.target.name, parseFloat(e.target.value))
                }}
            />
            <div style={{ position: 'absolute', display: "flex", flexDirection: "column", right: "5px", top: "3px", background: "transparent" }}>
                <i className="fa-solid fa-caret-up fa-xl" style={{ lineHeight: 0.75 }} onClick={(): void => onChange(name, value + 1)}></i>
                <i className="fa-solid fa-caret-down fa-xl" style={{ lineHeight: 0.70 }} onClick={(): void => onChange(name, value - 1)}></i>
            </div>
        </div>
    )
}
export default CustomNumberInputChanger